import SearchCatalog from './SearchCatalog'
import ProductCatalog from './ProductCatalog'
import PromoCatalog from './PromoCatalog'

export default function install(Vue) {
  Vue.component('ProductCatalog', ProductCatalog)
  Vue.component('PromoProductCatalog', PromoCatalog)
  Vue.component(SearchCatalog.name, SearchCatalog)
}
